<mat-drawer-container class="h-100" [hasBackdrop]="true">
  <mat-drawer #drawer mode="over">
    <lib-vakers-shell-ui-menu
      [user]="authService.firebaseUser()"
      [currentLanguage]="appStateService.appLanguage()"
      [currentCurrency]="appStateService.userCurrency()"
      [logo]="appStateService.toolbarLogo()"
      [languages]="LANGS"
      [currencies]="appStateService.currencies()"
      (languageSelected)="appStateService.changeAppLanguage($event)"
      (currencySelected)="appStateService.changeUserCurrency($event)"
      (logout)="authService.signOut()"
      (closeMenu)="drawer.toggle()"
    ></lib-vakers-shell-ui-menu
  ></mat-drawer>
  <mat-drawer-content>
    <lib-vakers-shell-ui-toolbar
      class="w-100"
      [logo]="appStateService.toolbarLogo()"
      [user]="authService.firebaseUser()"
      [userLoggedIn]="authService.userLoggedIn"
      [toolbar]="appStateService.toolbar()"
      [siteLogo]="appStateService.siteLogo()"
      [isVakiSite]="appStateService.isVakiSite()"
      [siteId]="appStateService.siteId()"
      [isOwner]="appStateService.lastVisitedVaki() | isOwner"
      [isOpen]="appStateService.lastVisitedVakiAnalytics() | isOpen"
      [backUrl]="appStateService.backUrl()"
      [vaki]="appStateService.lastVisitedVaki()"
      [vakiAnalytics]="appStateService.lastVisitedVakiAnalytics()"
      [currencies]="appStateService.currencies()"
      [currentCurrency]="appStateService.userCurrency()"
      [languages]="LANGS"
      [currentLanguage]="appStateService.appLanguage()"
      [hasRewards]="appStateService.hasRewards()"
      [hasSubscriptionPlans]="appStateService.hasSubscriptions()"
      (languageSelected)="appStateService.changeAppLanguage($event)"
      [editMode]="appStateService.editMode()"
      [cartTotalRewards]="cartService.rewardsTotal()"
      (logout)="authService.signOut()"
      (toggleEditMode)="appStateService.toggleEditMode()"
      (toggleMenu)="drawer.toggle()"
      (searchKeyword)="onSearch($event)"
      (openCartBottomSheet)="openCart()"
      (openSupportDialog)="supportVaki($event)"
    >
    </lib-vakers-shell-ui-toolbar>
    <div class="main-content" #container>
      <div class="pb-8">
        <router-outlet (activate)="onActive(container)"></router-outlet>
      </div>
      <footer *ngIf="(hideFooter$ | async) !== true">
        <lib-vakers-shell-ui-footer
          [currentLanguage]="appStateService.appLanguage()"
          [languages]="LANGS"
          [currentCurrency]="appStateService.userCurrency()"
          [currencies]="appStateService.currencies()"
          (languageSelected)="appStateService.changeAppLanguage($event)"
          (currencySelected)="appStateService.changeUserCurrency($event)"
        ></lib-vakers-shell-ui-footer>
      </footer>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
